import { render, staticRenderFns } from "./AdminSolarModules.vue?vue&type=template&id=3f1483a4&"
import script from "./AdminSolarModules.vue?vue&type=script&lang=js&"
export * from "./AdminSolarModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports